import { createAction } from "@reduxjs/toolkit";
import { ILogin, IVerifyOtp } from "../../types/authTypes";

export const loginUser = createAction<ILogin>("user/loginUser");
export const verifyOtp = createAction<IVerifyOtp>("user/verifyOtp");
export const userMe = createAction("user/user_me");
export const logout = createAction("user/reset_all_data");
